import React from "react";
import { TableIcon, CreditCard } from "lucide-react";

const ViewModeSelector = ({ viewMode, setViewMode }) => {
  return (
    <div className="inline-flex gap-x-2 bg-slate-200 shadow-md rounded-md p-2 items-center mb-4">
      <button
        onClick={() => setViewMode("table")}
        className={`flex items-center rounded-md p-2 ${
          viewMode === "table" ? "bg-blue-500 text-white" : "bg-gray-200"
        }`}
      >
        <TableIcon className="h-5 aspect-square" />
      </button>
      <button
        onClick={() => setViewMode("card")}
        className={`flex items-center rounded-md p-2 ${
          viewMode === "card" ? "bg-blue-500 text-white" : "bg-gray-200"
        }`}
      >
        <CreditCard className="h-5 aspect-square" />
      </button>
    </div>
  );
};

export default ViewModeSelector;
